import React from "react";

const QrCard = ({ data, onScanned, disabled, onRefresh, refreshing }) => {
  if (!data) return null;
  const qrUrl = data.QrPayload
    ? `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(data.QrPayload)}`
    : null;

  return (
    <div className="nav-card qr-card">
      {data.Subtitle && <div className="qr-subtitle">{data.Subtitle}</div>}
      <div className="qr-area">
        <div className="qr-inner-card">
          {qrUrl && <img src={qrUrl} alt="QR code" className="qr-image" />}
          <strong className="qr-label">
            {data.Title || "Scan to Authorize"}
          </strong>
          {data.Amount && (
            <small className="qr-amount">Transaction: {data.Amount}</small>
          )}
          {onRefresh ? (
            <button
              type="button"
              className="qr-refresh-btn"
              onClick={onRefresh}
              disabled={disabled || refreshing}
            >
              {refreshing ? "Refreshing..." : "Refresh QR"}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default QrCard;
